export * from "./propMerger";
export * from "./propFormatter";
//# sourceMappingURL=index.js.map